import { object, mixed, number } from '@calendly/form/validation'
import { I18n } from '@calendly/i18n'

const MAX_INVITEE_LIMIT = 9999

export const getMaxInviteesValidationSchema = (eventType) => object({
  inviteesLimit: mixed()
    .when(
      'isGroup',
      {
        is: () => eventType.isGroup,
        then: number()
          .typeError(I18n.t('errors.messages.not_a_number'))
          .integer()
          .required(I18n.t('activerecord.errors.models.event_type_base.attributes.invitees_limit.blank'))
          .lessThan(MAX_INVITEE_LIMIT + 1, I18n.t('errors.messages.less_than_or_equal_to', { count: MAX_INVITEE_LIMIT }))
          .moreThan(1, I18n.t('errors.messages.greater_than', { count: 1 }))
      }
    )
})
